import commonAxios from "@/views/csr/common/axios";
import axios from "axios";

const baseDomain = process.env.VUE_APP_API_URL;

const notificationApiService = {
  async getRecipients(search, page) {
    commonAxios.setHeader();
    const url = `/user?${
      search ? `search=${search}&` : ""
    }page=${page}&patients_only`;
    const response = await commonAxios.get(url);
    return response.data || null;
  },

  async send(formData) {
    const response = await commonAxios.post("/notification/send", formData);
    return response.data || null;
  },

  async getHistory(page, type) {
    const response = await axios.get(
      `${baseDomain}/api/v2/notification?page=${page}&per_page=15&type=${type}&with_users=1`
    );
    return response.data || null;
  },
};

export default notificationApiService;
